import React, { useRef, useState, Suspense, useCallback, useEffect } from "react";
import { Row } from "react-bootstrap";
import { FaEye, FaUpload, FaDownload } from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from "axios";
import config from "../config/Config";
import { apiHeaderToken, apiHeaderTokenMultiPart, getAppliedJobDetails } from "../helper/My_Helper";
import moment from "moment/moment";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Paper, Tooltip, Typography,Card,CardContent } from "@mui/material";
import { getCandidateById } from "../helper/Api_Helper";
import JoiningReportForm from "./JoiningReportForm";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import JoiningReportFormView from "./AnnuxureElevenJoiningFormView";
import DeclarationForm from "./DeclarationForm";
import UndertakeForm from "./UndertakeForm";
import { useLocation, useNavigate } from 'react-router-dom';
import SB_FormatView from "./SB_FormatView";
import SB_FormatEdit from "./SB_FormatEdit";
import CandidateIdCard from "./CandidateIdCard";
import GMCForm from "./GMC";
import GPAForm from "./GPA";
import JoiningChecklist from "./Checklist";
import Form12BBInstructions from "./Form12BBInstructions";
import GratuityNominationForm from "./GratuityNominationForm";
import Form12B from "./Form12B";
import ESICForm1 from "./ESICForm1";
import EPFForm2 from "./EPFForm2";
import EPFOForm11 from "./EPFOForm11";
import AppointmentLatter from "./AppointmentLatter";

const actionButtons = [
    { icon: <FaEye />, label: 'View', onClickKey: 'onView', color: '#1E88E5' },
    { icon: <FaDownload />, label: 'Download', onClickKey: 'onDownload', color: '#1E88E5' },
    { icon: <FaUpload />, label: 'Upload', onClickKey: 'onUpload', color: '#43A047' },
];

// Document configuration for HTML forms
// Document configuration for HTML forms
const HTML_DOC_CONFIG = {
    'ANNUXURE 11 JOINING FORM': {
        keywords: ['annuxure 11', 'joining form'],
        getStatus: (candidateData) => candidateData?.annexure_eleven_form_status === 'Complete',
        ViewComponent: JoiningReportFormView,
        EditComponent: JoiningReportForm,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },
    'SB_FORMAT': {
        keywords: ['sb_format', 'sb format'],
        getStatus: () => true, // Always show View
        ViewComponent: SB_FormatView,
        EditComponent: SB_FormatEdit,
        getViewProps: (candidateData) => ({
            candidateData,
            refereeData: candidateData?.referee_data,
            formData: candidateData?.sb_format_data
        }),
        getEditProps: (candidateData, referenceCandidate) => ({
            candidateData,
            refereeData: candidateData?.referee_data,
            initialFormData: candidateData?.sb_format_data,
            onSave: () => referenceCandidate(candidateData._id),
            onCancel: () => console.log('Cancel clicked')
        })
    },
    'Under form': {
        keywords: ['Under', 'Untitled'],
        getStatus: () => true,
        ViewComponent: UndertakeForm,
        EditComponent: UndertakeForm,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData) => ({
            candidateData
        })
    },
    'ID card format HLFPPT': {
        keywords: ['ID card format HLFPPT','ID Cart Formate for HLFPPT'],
        getStatus: () => true,
        ViewComponent: CandidateIdCard,
        EditComponent: CandidateIdCard,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({
            candidateData,
            referenceCandidate
        })
    },
    'GMC': {
        keywords: ['GMC','Insurance Declation Form'],
        getStatus: (candidateData) => {
            // Check if GMC form is complete - adjust based on your data structure
            const gmcStatus = candidateData?.applied_jobs?.find(
                item => item.job_id === candidateData?.job_id
            )?.gmc_form_status;
            return gmcStatus === 'Complete' || gmcStatus === 'agree' || gmcStatus === true;
        },
        ViewComponent: GMCForm,
        EditComponent: GMCForm,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },    
    'GPA': {
        keywords: ['GPA','Personal Accident Nomination'],
        getStatus: (candidateData) => {
            // Check if GPA form is complete - adjust based on your data structure
            const gpaStatus = candidateData?.applied_jobs?.find(
                item => item.job_id === candidateData?.job_id
            )?.gpa_form_status;
            return gpaStatus === 'Complete' || gpaStatus === 'agree' || gpaStatus === true;
        },
        ViewComponent: GPAForm,
        EditComponent: GPAForm,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },
    'Checklist': {
        keywords: ['checklist-new-(1)','checklist','check list new Docs'],
        getStatus: () => true, 
        ViewComponent: JoiningChecklist,
        EditComponent: JoiningChecklist,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },  
    'Form 12BB Instructions': {
        keywords: ['Form 12BB Instructions','Form - 12BB Instructions'],
        getStatus: () => true, 
        ViewComponent: Form12BBInstructions,
        EditComponent: Form12BBInstructions,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },
    'Gratuity Nomination Form': {
        keywords: ['Gratuity Nomination Form'],
        getStatus: () => true, 
        ViewComponent: GratuityNominationForm,
        EditComponent: GratuityNominationForm,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },   
    'Form12B': {
        keywords: ['Form12B (1) (1)','Form 12B'],
        getStatus: () => true, 
        ViewComponent: Form12B,
        EditComponent: Form12B,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },    
    'ESICForm1': {
        keywords: ['Form-1 ESIC Declaration Form (2)','Form-1 ESIC Declaration Form'],
        getStatus: () => true, 
        ViewComponent: ESICForm1,
        EditComponent: ESICForm1,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },
    'EPFForm2': {
        keywords: ['EPF - Nomination and Declaration Form','EPF - Nomination & Declaration Form - 2 revised'],
        getStatus: () => true, 
        ViewComponent: EPFForm2,
        EditComponent: EPFForm2,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },    
    'EPFO new Declaration Form 11': {
        keywords: ['EPFO new Declaration Form 11'],
        getStatus: () => true, 
        ViewComponent: EPFOForm11,
        EditComponent: EPFOForm11,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },
    'Declaration form': {
        keywords: ['declaration','decleration'],
        getStatus: (candidateData) => 
            candidateData?.applied_jobs?.find(item => item.job_id === candidateData?.job_id)?.declaration_form_status === 'agree',
        ViewComponent: DeclarationForm,
        EditComponent: DeclarationForm,
        getViewProps: (candidateData) => ({ candidateData }),
        getEditProps: (candidateData, referenceCandidate) => ({ 
            candidateData, 
            referenceCandidate 
        })
    },           
};

// Get the document config by matching document name
const getDocConfig = (docName) => {
    const upperName = docName?.toUpperCase() || '';
    for (const [, config] of Object.entries(HTML_DOC_CONFIG)) { // FIX: Removed unused 'key' variable
        if (config.keywords.some(keyword => upperName.includes(keyword.toUpperCase()))) {
            return config;
        }
    }
    return null;
};

const excludeFormas = (doc) => {
    const docName = doc?.doc_name?.trim().toLowerCase() || '';
    const fileName = doc?.send_file_data?.file_name?.trim().toLowerCase() || '';

    return (
        docName === 'application blank form personal data' ||
        fileName === 'application-blank-form-personal-data.doc'
    );
};


const DocumentTabs = ({ documents = [], handlers, candidateData, eventKeySteps, referenceCandidate, initialTabValue = 0 }) => {
    const webSetting = useSelector(state => state.jobs.webSettingData);
    const [value, setValue] = useState(initialTabValue);
    const [formData, setFormData] = useState({
        inductiveJoiningDate: '',
        loading: ''
    });
    const appliedJobDetails = getAppliedJobDetails(candidateData);

    const jsonData = sessionStorage.getItem('loginData');
    const dataObject = jsonData ? JSON.parse(jsonData) : null;

    useEffect(() => {
        setValue(initialTabValue);
    }, [initialTabValue]);

    const MakeFinalUploadsJoiningKits = async () => {
        setFormData((prev) => ({
            ...prev,
            loading: true
        }));

        try {
            const response = await axios.post(
                `${config.API_URL}updateOnboardStatusOfApprovalTimeLine`,
                {
                    candidate_id: dataObject?._id,
                    approval_note_id: candidateData?.applied_jobs?.find((item) => item?.job_id === candidateData?.job_id)?.approval_note_data?.doc_id,
                    form_step: 'Joining Kit',
                    add_by_name: dataObject?.name,
                    add_by_mobile: dataObject?.mobile_no,
                    add_by_designation: dataObject?.designation,
                    add_by_email: dataObject?.email
                },
                apiHeaderToken()
            );

            if (response.status === 200) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || error?.message || "Something went wrong");
        } finally {
            setFormData((prev) => ({
                ...prev,
                loading: false
            }));
        }
    };

    const handleStateChange = (obj) => {
        setFormData((prev) => ({
            ...prev,
            ...obj
        }));
    };

    const handleApprovedOrReject = async (status) => {
        try {
            if (!formData?.inductiveJoiningDate) {
                return toast.warn("Please Select the Tentative Date");
            }

            let payloads = {
                candidate_id: candidateData._id,
                applied_job_id: candidateData?.applied_jobs?.find(item => item?.job_id === candidateData?.job_id)?._id,
                action: status,
                tentative_date: formData?.inductiveJoiningDate
            };

            setFormData((pre) => ({
                ...pre,
                loading: status
            }));

            let response = await axios.post(`${config.API_URL}acceptRejectOffer`, payloads, apiHeaderToken());

            if (response.status === 200) {
                toast.success(response.data?.message);
                referenceCandidate(candidateData._id);
            } else {
                toast.error(response.data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message || "something went wrong");
        } finally {
            setFormData((pre) => ({
                ...pre,
                loading: ''
            }));
        }
    };
    if (eventKeySteps === 'offerletter') {
        const appliedJob = appliedJobDetails?.job_id ||  candidateData?.applied_jobs?.find(item => item?.job_id === candidateData?.job_id);
        const offerStatus = appliedJobDetails?.offer_status || appliedJob?.offer_status;

        if (offerStatus === 'Accepted') {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        gap: 3,
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        mt: 3,
                    }}
                >
                    <div className="acceptcase" style={{ textAlign: 'center' }}>
                        <img src={config.IMAGE_PATH + webSetting?.data?.logo_image} alt="Accepted" />
                        <p style={{ fontSize: "22px", fontWeight: 500, marginBottom: "20px", marginTop: 10 }}>
                            Thank you for accepting the offer. Welcome to {webSetting?.data?.organization_name || "HLFPPT"}!
                        </p>
                        <p style={{ fontSize: "19px", fontWeight: 400 }}>
                            You can expect the Joining Kit from us shortly.
                        </p>
                    </div>
                </Box>
            );
        }

        if (offerStatus === 'Rejected') {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        gap: 3,
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        mt: 3,
                    }}
                >
                    <div className="rejectcase" style={{ textAlign: 'center' }}>
                        <img src={config.IMAGE_PATH + webSetting?.data?.logo_image} alt="Rejected" />
                        <p style={{ fontSize: "22px", fontWeight: 500, marginBottom: "20px", marginTop: 10 }}>
                            Thank you for letting us know your decision.
                        </p>
                        <p style={{ fontSize: "19px", fontWeight: 400 }}>
                            We appreciate your interest in {webSetting?.data?.organization_name || "HLFPPT"} and wish you the best in your future endeavors.
                        </p>
                    </div>
                </Box>
            );
        }

        return (
            <Box sx={{ display: 'grid', width: '100%', height: '100%' }}>
            <Row className="text-center w-100 mt-3">
                    <div className="col-sm-4 manpwr_data_colm">
                        <h6>Name</h6>
                        <p>{candidateData?.name}</p>
                    </div>
                    <div className="col-sm-4 manpwr_data_colm">
                        <h6>Date Of Joining</h6>
                        <p>{appliedJobDetails?.onboard_date ? moment(appliedJobDetails.onboard_date).format('DD/MM/YYYY') : ''}</p>
                    </div>
                    <div className="col-sm-4 manpwr_data_colm">
                        <h6>Designation</h6>
                        <p>{appliedJobDetails?.job_designation || candidateData?.designation}</p>
                    </div>
                    <div className="col-sm-4 manpwr_data_colm">
                        <h6>Offered CTC</h6>
                        <p>{appliedJobDetails?.offer_ctc}</p>
                    </div>
                    <div className="col-sm-4 manpwr_data_colm">
                        <h6>Tentative Joining Date</h6>
                        <div className="position-relative">
                            <DatePicker
                                selected={formData.inductiveJoiningDate ? new Date(formData.inductiveJoiningDate) : null}
                                onChange={date =>
                                    handleStateChange({
                                        inductiveJoiningDate: moment(date).format('YYYY-MM-DD'),
                                    })
                                }
                                placeholderText="Select Date"
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                            />
                        </div>
                    </div>
            </Row>

                <Box
                    sx={{
                        display: 'flex',
                        gap: 3,
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        mt: 3,
                    }}
                >
                    <Button variant="contained" color="success" disabled={formData?.loading === 'accept'} onClick={() => handleApprovedOrReject("accept")}>
                        {formData?.loading === 'accept' ? "Loading...." : 'Accept'}
                    </Button>
                    <Button variant="contained" color="error" disabled={formData?.loading === 'reject'} onClick={() => handleApprovedOrReject("reject")}>
                        {formData?.loading === 'reject' ? "Loading...." : 'Reject'}
                    </Button>
                </Box>
            </Box>
        );
    }

    if (eventKeySteps === 'joiningkit') {
        if (!documents || !Array.isArray(documents)) {
            return <Typography>No documents available</Typography>;
        }

        // Filter documents for Joining Kit category
        const joiningKitDocs = documents.filter(
            doc =>
                doc.doc_category === 'Joining Kit' &&
                !excludeFormas(doc)
        );
        
        // Separate HTML and PDF documents
        const htmlDocs = joiningKitDocs.filter(doc => doc.is_html === 'Yes');
        const pdfDocs = joiningKitDocs.filter(doc => doc.is_html === 'No');

        // Build ordered list of HTML documents based on config
        const orderedHtmlDocs = [];
        
        // Add documents in the order defined by HTML_DOC_CONFIG
        for (const [, config] of Object.entries(HTML_DOC_CONFIG)) { // FIX: Removed unused 'docName' variable
            const foundDoc = htmlDocs.find(doc => 
                config.keywords.some(keyword => 
                    doc.doc_name?.toUpperCase().includes(keyword.toUpperCase())
                )
            );
            if (foundDoc) {
                orderedHtmlDocs.push({
                    ...foundDoc,
                    completeStatus: config.getStatus(candidateData)
                });
            }
        }

        // Add any remaining HTML docs that weren't matched
        const matchedIds = new Set(orderedHtmlDocs.map(doc => doc._id));
        const remainingHtmlDocs = htmlDocs
            .filter(doc => !matchedIds.has(doc._id))
            .map(doc => ({
                ...doc,
                completeStatus: false // Default status for unknown HTML docs
            }));
        orderedHtmlDocs.push(...remainingHtmlDocs);

        // Combine HTML and PDF docs
        const allDocs = [...orderedHtmlDocs, ...pdfDocs];

        const activeDoc = allDocs[value];

        // Render the appropriate component for a document
        const renderDocumentContent = (doc) => {
            console.log('Document:', {
                name: doc.doc_name,
                isHtml: doc.is_html,
                status: doc.status,
                completeStatus: doc.completeStatus
            });
            if (doc.is_html === 'Yes') {
                const config = getDocConfig(doc.doc_name);
                if (config) {
                    const isComplete = config.getStatus(candidateData);
                    const Component = isComplete ? config.ViewComponent : config.EditComponent;
                    const props = isComplete 
                        ? config.getViewProps(candidateData)
                        : config.getEditProps(candidateData, referenceCandidate);
                    return <Component {...props} />;
                }
                // Fallback for unknown HTML docs
                return <Typography>No preview available for {doc.doc_name}</Typography>;
            } else {
                // PDF and other non-HTML documents - show action buttons
                return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', alignItems: 'center' }}>
                        {actionButtons.map((btn, index) => (
                            <Tooltip key={`${btn.label}-${index}`} title={btn.label}>
                                <IconButton
                                    onClick={() => handlers[btn.onClickKey](doc)}
                                    sx={{
                                        backgroundColor: `${btn.color}10`,
                                        color: btn.color,
                                        border: `1px solid ${btn.color}30`,
                                    }}
                                >
                                    {btn.icon}
                                </IconButton>
                            </Tooltip>
                        ))}
                    </Box>
                );
            }
        };

        return (
            <Box sx={{ width: '100%', height: '100%' }}>
        
                {/* Document Content */}
                <Box sx={{ flexGrow: 1, p: 2, overflow: 'auto' }}>
                    {activeDoc ? (
                        <Box
                            sx={{
                                p: 3,
                                backgroundColor: 'background.paper',
                                width: '100%',
                                maxWidth: '1200px',
                                mx: 'auto',
                                my: 2,
                                minHeight: '400px'
                            }}
                        >
                            {renderDocumentContent(activeDoc)}
                        </Box>
                    ) : (
                        <Typography textAlign="center" sx={{ py: 4 }}>
                            No documents available
                        </Typography>
                    )}
                </Box>

                {/* Final Submit button */}
                {allDocs?.every((item) =>
                    (item.is_html === 'Yes' && item?.completeStatus === true) ||
                    (item.is_html === 'No' && item?.status === 'complete')
                ) && allDocs.length > 0 && (
                    <div className="d-flex justify-content-center align-items-center" style={{ padding: '20px 0' }}>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={MakeFinalUploadsJoiningKits}
                            disabled={formData.loading}
                            sx={{ minWidth: '200px' }}
                        >
                            {formData.loading ? "Loading..." : "Make the Final Submit"}
                        </Button>
                    </div>
                )}
            </Box>
        );
    }

    if (eventKeySteps === 'appointmentletter') {
        return (
            <Box sx={{ width: '100%', height: '100%' }}>
                <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: 1 }}>
                    <CardContent>
                        <Suspense fallback={<Typography sx={{ textAlign: 'center' }} variant="body2">Loading Appointment Letter…</Typography>}>
                            <AppointmentLatter candidateData={candidateData} />
                        </Suspense>
                    </CardContent>
                </Card>
            </Box>
        );
    }

    return null;
};

const VerifiedDocument = () => {
    const [documents, setDocuments] = useState({});
    const navigate = useNavigate();
    const uploadInputRef = useRef(null);
    const [pendingUploadDoc, setPendingUploadDoc] = useState(null);

    const jsonData = sessionStorage.getItem('loginData');
    const dataObject = jsonData ? JSON.parse(jsonData) : null;
    const [candidateData, setCandidateData] = useState(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const selectedDocName = queryParams.get('doc_name');

    const GetCandidateUploadsDocument = useCallback(async () => {
        try {
            const appliedJob =
                candidateData?.applied_jobs?.find(
                    item =>
                        item?.approval_note_data?.note_id &&
                        (item?.form_status === "Offer" ||
                         item?.form_status === "Hired")
                ) ||
                candidateData?.applied_jobs?.find(
                    item => item?.job_id === candidateData?.job_id
                );

            const response = await axios.post(
                `${config.API_URL}getOnboardDocuments`,
                {
                    candidate_id: dataObject?._id,
                    approval_note_id: appliedJob?.approval_note_data?.doc_id,
                },
                apiHeaderToken()
            );
    
            if (response.status === 200) {
                setDocuments(response.data?.data || {});
            } else {
                setDocuments({});
            }
        } catch (error) {
            console.error(error);
            setDocuments({});
        }
    }, [dataObject?._id, candidateData]);

    const getInitialTabValue = () => {
        if (!documents || !selectedDocName) return 0;

        if (documents.onboarding_docs_stage === 'joiningkit' || documents.onboarding_docs_stage === 'complete') {
            const allDocs = documents.onboarding_docs?.filter(
                item =>
                    item?.doc_category === 'Joining Kit' &&
                    !excludeFormas(item)
            ) || [];

            // Get HTML docs in the same order as defined in config
            const htmlDocs = allDocs.filter(doc => doc.is_html === 'Yes');
            const pdfDocs = allDocs.filter(doc => doc.is_html === 'No');

            // Build ordered list matching the config order
            const orderedHtmlDocs = [];
            for (const [, config] of Object.entries(HTML_DOC_CONFIG)) { // FIX: Removed unused 'docName' variable
                const foundDoc = htmlDocs.find(doc => 
                    config.keywords.some(keyword => 
                        doc.doc_name?.toUpperCase().includes(keyword.toUpperCase())
                    )
                );
                if (foundDoc) {
                    orderedHtmlDocs.push(foundDoc);
                }
            }

            // Add remaining HTML docs
            const matchedIds = new Set(orderedHtmlDocs.map(doc => doc._id));
            const remainingHtmlDocs = htmlDocs.filter(doc => !matchedIds.has(doc._id));
            orderedHtmlDocs.push(...remainingHtmlDocs);

            // Combine all docs
            const allOrderedDocs = [...orderedHtmlDocs, ...pdfDocs];

            const targetIndex = allOrderedDocs.findIndex(
                doc => doc?.doc_name?.trim().toUpperCase() === selectedDocName.trim().toUpperCase()
            );

            if (targetIndex !== -1) {
                return targetIndex;
            }
        }

        return 0;
    };

    const [value, setValue] = useState(0);

    useEffect(() => {
        if (documents && Object.keys(documents).length > 0) {
            const initial = getInitialTabValue();
            setValue(initial);
        }
    }, [documents, selectedDocName]);

    const GetCandidateRecordsBaseOnEvent = async (id = '') => {
        try {
            const response = await getCandidateById({ _id: id, scope_fields: [] });
            setCandidateData(response.data ?? {});
        } catch (error) {
            console.error('Error fetching candidate:', error);
            setCandidateData(null);
        }
    };

    useEffect(() => {
        if (dataObject?._id) {
            GetCandidateRecordsBaseOnEvent(dataObject?._id);
        }
    }, [dataObject?._id]);

    const handleFilesSelected = async (files, doc) => {
        if (!files || !files.length) return;

        const formData = new FormData();
        Array.from(files).forEach((file, idx) => {
            formData.append(`attachments[${idx}][doc_name]`, file?.name);
            formData.append(`attachments[${idx}][file_name]`, file);
        });

        formData.append('onboard_doc_id', doc._id);
        formData.append('approval_note_id', doc?.approval_note_doc_id);
        formData.append('candidate_id', dataObject?._id);
        formData.append("add_by_name", "Candidate");
        formData.append("add_by_mobile", "");
        formData.append("add_by_designation", '');
        formData.append("add_by_email", '');

        try {
            const response = await axios.post(
                `${config.API_URL}uploadOnboardingDocuments`,
                formData,
                apiHeaderTokenMultiPart()
            );
        
            if (response.status === 200) {
                toast.success(
                    response?.data?.message || "Document uploaded successfully"
                );
        
                GetCandidateUploadsDocument();
            } else {
                toast.error(
                    response?.data?.message ||
                    response?.data?.error?.message ||
                    "Upload failed"
                );
            }
        
        } catch (err) {
            console.error("Upload failed:", err);
        
            const errorMessage =
                err?.response?.data?.error?.message ||
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong";
        
            toast.error(errorMessage);
        }
    };

    const handlers = {
        onView: doc => {
            const fileUrl = doc?.uploaded_file_data?.file_name ? config.IMAGE_PATH + doc?.uploaded_file_data?.file_name : config.IMAGE_PATH + doc?.send_file_data?.file_name;
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
        },
        onDownload: async doc => {
            const fileUrl = doc?.uploaded_file_data?.file_name ? config.IMAGE_PATH + doc?.uploaded_file_data?.file_name : config.IMAGE_PATH + doc?.send_file_data?.file_name;
            const fileName = doc?.uploaded_file_data?.file_name ? doc?.uploaded_file_data?.file_name : doc?.send_file_data?.file_name || 'download';
            try {
                const response = await fetch(fileUrl, { mode: 'cors' });
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.error('Download failed:', err);
                toast.error('Download failed.');
            }
        },
        onUpload: doc => {
            setPendingUploadDoc(doc);
            uploadInputRef.current?.click();
        }
    };

    useEffect(() => {
        AOS.init({ duration: 800, once: true });
        GetCandidateUploadsDocument();
    }, [GetCandidateUploadsDocument]);

    const steps = [
        documents?.onboarding_docs_stage === 'offerletter' && {
            eventKey: 'offerletter',
            title: 'Offer Letter',
            docs: documents?.onboarding_docs?.filter(item => item?.doc_category === 'Offer Letter') || [],
            editMode: documents?.onboarding_docs_stage === 'offerletter'
        },
        documents?.onboarding_docs_stage === 'joiningkit' && {
            eventKey: 'joiningkit',
            title: 'Joining Kit',
            docs: documents?.onboarding_docs?.filter(item => item?.doc_category === 'Joining Kit') || [],
            editMode: documents?.onboarding_docs_stage === 'joiningkit'
        },
        documents?.onboarding_docs_stage === 'appointmentletter' && {
            eventKey: 'appointmentletter',
            title: 'Appointment Letter',
            docs: documents?.onboarding_docs?.filter(item => item?.doc_category === 'Appointment Letter') || [],
            editMode: documents?.onboarding_docs_stage === 'appointmentletter'
        },
    ].filter(step => step);

    const [activeStep, setActiveStep] = useState(0);
    // FIX: Removed unused 'previewMode' state and replaced with underscore
    const [, setPreviewMode] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);

    useEffect(() => {
        if (documents?.onboarding_docs_stage === 'offerletter') {
            setActiveStep(0);
        } else if (documents?.onboarding_docs_stage === 'joiningkit') {
            setActiveStep(1);
        } else if (documents?.onboarding_docs_stage === 'appointmentletter') {
            setActiveStep(2);
        } else if (documents?.onboarding_docs_stage === 'complete') {
            setPreviewMode(true);
        }
    }, [documents?.onboarding_docs_stage, steps.length, setPreviewMode]);

    const updateOnboardingStage = async (stage) => {
        try {
            const response = await axios.post(
                `${config.API_URL}update_candidate_onboard_mail_steps`,
                {
                    candidate_doc_id: dataObject?._id,
                    applied_job_id: candidateData?.applied_jobs?.find((item) => item?.job_id === candidateData?.job_id)?._id,
                    action: stage
                },
                apiHeaderToken()
            );

            if (response.status === 200) {
                toast.success(response.data.message);
                GetCandidateUploadsDocument();
                const lastStepKey = steps.length > 0 ? steps[steps.length - 1].eventKey.toLowerCase() : '';

                if (stage === lastStepKey) {
                    setPreviewMode(true);
                } else {
                    setActiveStep(step => Math.min(step + 1, steps.length - 1));
                }
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || error?.message || "Something went wrong");
        } finally {
            setOpenAlert(false);
        }
    };

    useEffect(() => {
        if (activeStep >= steps.length) {
            setActiveStep(steps.length > 0 ? steps.length - 1 : 0);
        }
    }, [activeStep, steps.length]);

    return (
        <>
            <div className="maincontent">
                <div className="container px-2 px-sm-3 animate__animated animate__fadeIn animate__slower">
                    <div className="contentwrap" style={{ width: '100%' }}>
                        <div className="contentbox" style={{ width: '100%' }}>
                            <div className="contenthdr">
                                <h4>{selectedDocName || "OnBoard Documents"}</h4>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        if (window.history.length > 1) {
                                            navigate(-1);
                                        } else {
                                            navigate("/dashboard");
                                        }
                                    }}
                                >
                                    Back
                                </Button>
                            </div>
                            <Box>
                                <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
                                    {steps.length > 0 && steps[activeStep] ? (
                                        <DocumentTabs
                                            documents={steps[activeStep]?.docs || []}
                                            handlers={handlers}
                                            candidateData={candidateData}
                                            eventKeySteps={steps[activeStep]?.eventKey}
                                            referenceCandidate={GetCandidateRecordsBaseOnEvent}
                                            initialTabValue={value}
                                        />
                                    ) : (
                                        <Typography textAlign={'center'}>No Action available.</Typography>
                                    )}
                                </Paper>
                            </Box>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                theme="dark"
                limit={1}
            />

            <input
                type="file"
                ref={uploadInputRef}
                style={{ display: 'none' }}
                onChange={e => {
                    handleFilesSelected(e.target.files, pendingUploadDoc);
                    e.target.value = null;
                }}
            />

            <Dialog
                open={openAlert}
                onClose={() => setOpenAlert(false)}
                aria-describedby="confirm-dialog-description"
                aria-labelledby="confirm-dialog-title"
            >
                <DialogTitle
                    id="confirm-dialog-title"
                    sx={{
                        color: theme => theme.palette.warning.main,
                    }}
                >
                    Alert
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Please verify that you have reviewed all documents for “{steps[activeStep]?.title}”.
                        <br /><br />
                        <strong>This action cannot be undone.</strong><br />
                        Are you sure you want to submit this step?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenAlert(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={() => {
                        const stageMap = ['offerletter', 'joiningkit', 'appointmentletter'];
                        updateOnboardingStage(stageMap[activeStep]);
                    }} variant="contained" color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default VerifiedDocument;